export const menuFixer = () => {
  const headerElement = document.querySelector('.js-header') as HTMLElement

  // Kill this if the header element is not found
  if (!headerElement) { return }

  // On scrolling
  window.addEventListener('scroll', () => {
    checkStickyMenu()
  })

  // On resize
  window.addEventListener('resize', () => {
    checkStickyMenu()
  })

  // Handle all the fancy transitions
  const checkStickyMenu = () => {
    const wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement
    const scrollTop = window.pageYOffset
    const isScrolled = scrollTop > headerElement.clientHeight
    const wpBarHeightScroll = (wpAdminBar && window.innerWidth > 600) ? wpAdminBar.clientHeight : 0

    if (isScrolled) {
      headerElement.style.marginTop = `${wpBarHeightScroll}px`
      headerElement.classList.add('-isScrolledTransition')
      setTimeout(() => {
        if (headerElement.classList.contains('-isScrolledTransition')) {
          headerElement.classList.add('-isScrolled')
        }
      }, 25)
    } else {
      if (scrollTop === 0) {
        headerElement.style.marginTop = '0px'
        headerElement.classList.remove('-isScrolled')
        headerElement.classList.remove('-isScrolledTransition')
      }
    }
  }

  // Select the node that will be observed for mutations
  const bodyElement = document.querySelector('body')

  if (bodyElement) {
    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: false }

    const fixWpAdminBarAddition = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (mutation.addedNodes.length > 0) {
            if (mutation.addedNodes[0].id === 'wpadminbar') {
              checkStickyMenu()
              observer.disconnect()
            }
          }
        }
      }
    }

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(fixWpAdminBarAddition)

    // Start observing the target node for configured mutations
    observer.observe(bodyElement, config)
  }

  // Run once on load
  checkStickyMenu()
}
